// Data Program Studi
export const dataProdi = [
    {
        prodi_id: 1,
        prodi_nama: "Teknik Informatika",
        prodi_kode: "TI",
        fakultas_id: 3,
        fakultas_nama: "Fakultas Ilmu Komputer",
        jenjang: "S1",
        kaprodi_id: "DSN001",
        kaprodi_nama: "Dr. Citra Dewi, S.Kom., M.Cs.",
        akreditasi: "A",
        status: 1
    },
    {
        prodi_id: 2,
        prodi_nama: "Sistem Informasi",
        prodi_kode: "SI",
        fakultas_id: 3,
        fakultas_nama: "Fakultas Ilmu Komputer",
        jenjang: "S1",
        kaprodi_id: "DSN003",
        kaprodi_nama: "Ir. Dedi Hartono, M.Kom.",
        akreditasi: "B",
        status: 1
    },
    {
        prodi_id: 3,
        prodi_nama: "Teknik Mesin",
        prodi_kode: "TM",
        fakultas_id: 1,
        fakultas_nama: "Fakultas Teknik",
        jenjang: "S1",
        kaprodi_id: "DSN004",
        kaprodi_nama: "Dr. Eko Prasetyo, S.T., M.T.",
        akreditasi: "A",
        status: 1
    },
    {
        prodi_id: 4,
        prodi_nama: "Teknik Elektro",
        prodi_kode: "TE",
        fakultas_id: 1,
        fakultas_nama: "Fakultas Teknik",
        jenjang: "S1",
        kaprodi_id: "DSN005",
        kaprodi_nama: "Ir. Fajar Nugroho, M.T.",
        akreditasi: "B",
        status: 1
    },
    {
        prodi_id: 5,
        prodi_nama: "Manajemen",
        prodi_kode: "MNJ",
        fakultas_id: 2,
        fakultas_nama: "Fakultas Ekonomi dan Bisnis",
        jenjang: "S1",
        kaprodi_id: "DSN006",
        kaprodi_nama: "Dr. Gita Permata, S.E., M.M.",
        akreditasi: "A",
        status: 1
    },
    {
        prodi_id: 6,
        prodi_nama: "Akuntansi",
        prodi_kode: "AKT",
        fakultas_id: 2,
        fakultas_nama: "Fakultas Ekonomi dan Bisnis",
        jenjang: "S1",
        kaprodi_id: "DSN007",
        kaprodi_nama: "Hendra Wijaya, S.E., M.Ak.",
        akreditasi: "B",
        status: 1
    }
];

export const dropdownProdi = dataProdi.map(p => ({
    value: p.prodi_id,
    label: `${p.prodi_nama} (${p.jenjang})`
}));

export default dataProdi;
